require('./bootstrap');
window.Vapor = require('laravel-vapor');